<template>
  <v-card
    :style="{ 'opacity': old ? '0.3' : '1'}"
    style="border-radius: 10px;padding:0;"
    :elevation="3"
  >
    <v-layout
      row
      wrap
      style="height:100%;background-color:none;"
    >
      <v-flex
        xs4
        height="100%"
        style="padding:0;"
      >
        <v-img
          :src="image"
          :lazy-src="image"
          height="100%"
          width="90%"
          aspect-ratio="1.7"
          class="grey lighten-2"
          style="border-radius: 10px 0 0px 10px;"
        />
      </v-flex>
      <v-flex
        :style="{ 'color': activityColor1 }"
        xs8
      >
        <v-layout
          row
          wrap
          style="margin-top:5px;margin-bottom:0px;"
        >
          <v-flex
            xs8
            class="title"
            :style="{ 'color' : activityColor1 ? activityColor1 : '#666666'}"
          >
            {{ title }}
          </v-flex>
          <v-flex
            xs12
            style="text-align: left;padding-top: 0px;padding-bottom: 0px;"
          >
            <v-icon
              class="time-icon"
              :style="{ 'color': active ? 'rgb(85,173,11)' : activityColor2 ? activityColor2 : '#BF9D5A'}"
            >
              mdi-clock-outline
            </v-icon>
            <span
              class="time-text"
              :style="{ 'color': active ? 'rgb(85, 173, 11)' : activityColor2 ? activityColor2 : '#BF9D5A'}"
            >
            {{ time }}
            </span>
          </v-flex>
          <v-flex
            xs12
            class="subtitle-main"
          >
            <span
              class="subtitle"
              :style="{ 'opacity': subtitle && subtitle.length > 0 ? '1' : '0', 'color': activityColor4 ? activityColor4 : '#999999'}"
              v-html="subtitle && subtitle.length > 0 ? subtitle : '.'"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    name: 'ActivityItemRow',
    props: {
      data: {
        type: Object,
        default: null,
      },
      color1: {
        type: String,
        default: null,
      },
      color2: {
        type: String,
        default: null,
      },
      color3: {
        type: String,
        default: null,
      },
      color4: {
        type: String,
        default: null,
      },
    },
  data () {
    return {
      image: null,
      time: null,
      title: null,
      subtitle: null,
      active: false,
      old: false,
      height: 232,
      activityColor1: null,
      activityColor2: null,
      activityColor3: null,
      activityColor4: null,
    }
  },
  watch: {
    'data.image' () { 
      this.prepareData() 
    },
    'data.time' () { 
      this.prepareData()
    },
    'data.title' () { 
      this.prepareData()
    },
    'data.subtitle' () { 
      this.prepareData()
    },
    'data.active' () { 
      this.prepareData()
    },
    'data.old' () { 
      this.prepareData()
    },
    'data.color1' () { 
      this.prepareData()
    },
    'data.color2' () { 
      this.prepareData()
    },
    'data.color3' () { 
      this.prepareData()
    },
    'data.color4' () { 
      this.prepareData()
    },
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    prepareData () {
      this.image = this.data.image
      this.time = this.data.time
      this.title = this.data.title
      this.subtitle = this.data.subtitle
      this.active = this.data.active ? true : false
      this.old = this.data.old ? true : false
      this.activityColor1 = this.data.color1
      this.activityColor2 = this.data.color2
      this.activityColor3 = this.data.color3
      this.activityColor4 = this.data.color4
    },
  },
}
</script>
<style scoped>
.title {
  font-size: 1.8rem !important;
  text-align: left;
  padding: 5px 0 5px 0;
  line-height: 1.8rem;
}
.time-icon {
  margin-left: 0px;
  margin-top: -10px;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 1.8rem;
}
.time-text {
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 1.8rem;
}
.subtitle-main {
  padding: 5px 20px 15px 0;
}
.subtitle {
  text-align: left;
  font-size: 1rem;
  line-height: 1rem;
}
</style>
